import React from 'react';

import Swal from 'sweetalert2';

import { func_validation } from 'functions';

export function Toaster(props) {
    const { type, msg, position, timer, 
            isTimerProgressBarHidden, isTimerStop_onMouseEnter_NotRequired } = props;

    // Validate Props
    let type_formatted = "";
    if (func_validation.isStringTrimNotEmpty(type)) type_formatted = type;
    let msg_formatted = "";
    if (func_validation.isStringTrimNotEmpty(msg)) msg_formatted = msg;
    let position_formatted = "top-end";
    if (func_validation.isStringTrimNotEmpty(position)) position_formatted = position;
    let timer_formatted = 5000;
    if (func_validation.isNumberValid(timer)) timer_formatted = timer;

    const toaster = Swal.mixin({
        toast: true,
        position: position_formatted,
        showConfirmButton: false,
        timer: timer_formatted,
        timerProgressBar: !isTimerProgressBarHidden,
        onOpen: (toast) => {
            if (!isTimerStop_onMouseEnter_NotRequired) {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        }
    });
      
    toaster.fire({
        icon: type_formatted,
        title: msg_formatted
    })

    return toaster;
}